import React from 'react';

import { makeStyles } from '@material-ui/core/styles';
import { AppBar, Button, Toolbar } from '@material-ui/core';

import Logo from '../../assets/white-logo.png'

const useStyles = makeStyles((theme) => ({
    // [theme.breakpoints.up('xs')]: {}
    // [theme.breakpoints.up('sm')]: {}
    // [theme.breakpoints.up('md')]: {}
    // [theme.breakpoints.up('xl)]: {}
    root: {
    },
    logo: {
        maxHeight: 30
    },
}))

export default function Header(props) {
    const classes = useStyles();

    return (
        <AppBar elevation={0} position="fixed">
            <Toolbar>
                <img className={classes.logo} src={Logo} />
            </Toolbar>
        </AppBar>
    )
}